/**
 * Updates external links to go.sysdig.com with current utm values
 */

'use strict';

export class PathFactoryLinkUTMs {
    constructor() {
        this.config = {
            utm: {
                'utm_campaign': localStorage.getItem('utm_campaign'),
                'utm_content': localStorage.getItem('utm_content'),
                'utm_medium': localStorage.getItem('utm_medium'),
                'utm_offer': localStorage.getItem('utm_offer'),
                'utm_source': localStorage.getItem('utm_source'),
                'utm_term': localStorage.getItem('utm_term'),
            }
        }
    }

    init() {
        this.update_links();
    }

    update_links() {

        const links = document.querySelectorAll('[href*="go.sysdig.com"]');

        if (links.length === 0) {
            return false;
        }

        links.forEach((link) => {

            const url = new URL(link.getAttribute('href'));
            let searchParams = new URLSearchParams(url.search);

            for (const [key, value] of Object.entries(this.config.utm)) {
                if (!searchParams.has(key) && value) {
                    searchParams.append(key, value);
                }
            }

            link.setAttribute('href', `${url.origin}${url.pathname}?${searchParams.toString()}`);

        });
    }
}